import {
  pageToPixel,
  pixelToCanvas,
  canvasToPixel,
  setToPixelCoordinateSystem
} from "./coordinate.js";

const coordinate = {
  pageToPixel,
  pixelToCanvas,
  canvasToPixel,
  setToPixelCoordinateSystem
};

export default coordinate;
